<template>
  <div class="rules">
    <div class="rules__nav">
      <button aria-label="返回" @click="$emit('back')"></button>
      <span>规则 & 好礼</span>
      <i></i>
    </div>
    <div v-if="state === 'loading'" class="rules__state">加载中...</div>
    <div v-else-if="state === 'error'" class="rules__state">
      {{ errorText }} <button @click="load">重试</button>
    </div>
    <div v-else class="rules__content" v-html="rulesHtml"></div>
  </div>
</template>

<script>
import { getRules } from '@/api/worldcupQuiz'
import { sanitizeRulesHtml } from '../utils/sanitize'
import { unwrapResponse, waitForNativeTouchEnd } from '../utils'

const DEFAULT_RULES_HTML = '<h3>活动规则</h3><p>每场竞猜消耗门票默往币，猜中即可获得 1 次抽奖机会。</p><p>奖品以抽奖中心展示为准，100% 中奖。</p>'

export default {
  name: 'WorldCupQuizRules',
  data () {
    return {
      state: 'loading',
      rulesHtml: '',
      errorText: '加载失败'
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.state = 'loading'
      try {
        await waitForNativeTouchEnd()
        const data = unwrapResponse(await this.getRulesWithRetry())
        this.rulesHtml = sanitizeRulesHtml(data && data.rules_html ? data.rules_html : DEFAULT_RULES_HTML)
        this.state = 'success'
      } catch (error) {
        this.rulesHtml = sanitizeRulesHtml(DEFAULT_RULES_HTML)
        this.state = 'success'
      }
    },
    async getRulesWithRetry () {
      const options = {
        skipToast: true,
        skipToastOnStatus0: true
      }
      try {
        return await getRules(options)
      } catch (error) {
        await waitForNativeTouchEnd()
        return getRules(options)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.rules {
  min-height: 100vh;
  background: #145720;
}

.rules__nav {
  position: sticky;
  top: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: calc(var(--quiz-safe-top, 0px) + var(--quiz-nav-height, 48px));
  padding: var(--quiz-safe-top, 0px) 14px 0;
  box-sizing: border-box;
  background: transparent;
}

.rules__nav button {
  position: relative;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
}

.rules__nav button:before {
  content: "";
  position: absolute;
  top: 9px;
  left: 10px;
  width: 10px;
  height: 10px;
  border-left: 2px solid rgba(255, 255, 255, .92);
  border-bottom: 2px solid rgba(255, 255, 255, .92);
  transform: rotate(45deg);
}

.rules__nav span {
  color: #fff7d2;
  font-size: 16px;
  font-weight: 900;
}

.rules__nav i {
  width: 32px;
}

.rules__state {
  padding: 60px 0;
  color: rgba(255, 255, 255, .72);
  text-align: center;
  font-size: 14px;
}

.rules__state button {
  margin-left: 8px;
  border: 0;
  color: #ffdf59;
  background: transparent;
  font-weight: 800;
}

.rules__content {
  margin: 14px;
  padding: 16px;
  border-radius: 8px;
  color: rgba(255, 255, 255, .84);
  border: 1px solid rgba(255, 219, 86, .2);
  background: rgba(8, 48, 20, .88);
  font-size: 14px;
  line-height: 1.8;
  word-break: break-word;
}

.rules__content ::v-deep img {
  max-width: 100%;
  height: auto;
}
</style>
